// 递归获取当前文件夹下的所有.json文件
const lang = {}
const files = require.context('./', true, /\.json$|\.js$/)
files.keys().forEach((key) => {
  if (key === './index.js') {
    return
  }
  let name = ''
  let path = key.replace(/(\.\/|\.json)|(\.\/|\.js)/g, '').replace('_', '-')
  const splitNameArr = path.split('-')
  splitNameArr.forEach((item, index) => {
    if (index !== 0) item = item.charAt(0).toUpperCase() + item.slice(1)
    name += item
  })
  let type = name.split('/')[0]
  let item = name.split('/')[1]
  if (!lang[type]) {
    lang[type] = {}
  }
  if (!lang[type][item]) {
    lang[type][item] = {}
  }
  if ((/\.json$/).test(key)) {
    lang[type][item] = files(key)
  } else {
    lang[type][item] = files(key).default
  }
})
// console.log('lang>>>>>', lang);

export default lang
